/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/InsightReport', 'model/Insight', 'model/InsightCompanyData', 'model/InsightFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/InsightReport'), require('../model/Insight'), require('../model/InsightCompanyData'), require('../model/InsightFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InsightApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.InsightReport, root.ForStractionServiceApi.Insight, root.ForStractionServiceApi.InsightCompanyData, root.ForStractionServiceApi.InsightFilter);
  }
}(this, function(ApiClient, InsightReport, Insight, InsightCompanyData, InsightFilter) {
  'use strict';

  /**
   * Insight service.
   * @module api/InsightApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new InsightApi. 
   * @alias module:api/InsightApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the insightAddInsightImagePut operation.
     * @callback module:api/InsightApi~insightAddInsightImagePutCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addInsightImage
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/String>} body 
     * @param {module:api/InsightApi~insightAddInsightImagePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.insightAddInsightImagePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightAddInsightImagePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightAddInsightImagePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Insight/addInsightImage', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightAddPut operation.
     * @callback module:api/InsightApi~insightAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/InsightReport} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.sendNotifications  (default to false)
     * @param {module:api/InsightApi~insightAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.insightAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'sendNotifications': opts['sendNotifications']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Insight/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightAddUriScreenshotGet operation.
     * @callback module:api/InsightApi~insightAddUriScreenshotGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addUriScreenshot
     * @param {String} _4SAPIAppID 
     * @param {String} externalUri 
     * @param {module:api/InsightApi~insightAddUriScreenshotGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.insightAddUriScreenshotGet = function(_4SAPIAppID, externalUri, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightAddUriScreenshotGet";
      }

      // verify the required parameter 'externalUri' is set
      if (externalUri == undefined || externalUri == null) {
        throw "Missing the required parameter 'externalUri' when calling insightAddUriScreenshotGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'externalUri': externalUri
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/Insight/addUriScreenshot', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightDeleteGet operation.
     * @callback module:api/InsightApi~insightDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} insightID 
     * @param {module:api/InsightApi~insightDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.insightDeleteGet = function(_4SAPIAppID, insightID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightDeleteGet";
      }

      // verify the required parameter 'insightID' is set
      if (insightID == undefined || insightID == null) {
        throw "Missing the required parameter 'insightID' when calling insightDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'insightID': insightID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Insight/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightEditPut operation.
     * @callback module:api/InsightApi~insightEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/Insight} body 
     * @param {module:api/InsightApi~insightEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.insightEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Insight/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightGetCompanyDataFromUriGet operation.
     * @callback module:api/InsightApi~insightGetCompanyDataFromUriGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InsightCompanyData} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getCompanyDataFromUri
     * @param {String} _4SAPIAppID 
     * @param {String} externalUri 
     * @param {module:api/InsightApi~insightGetCompanyDataFromUriGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InsightCompanyData}
     */
    this.insightGetCompanyDataFromUriGet = function(_4SAPIAppID, externalUri, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightGetCompanyDataFromUriGet";
      }

      // verify the required parameter 'externalUri' is set
      if (externalUri == undefined || externalUri == null) {
        throw "Missing the required parameter 'externalUri' when calling insightGetCompanyDataFromUriGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'externalUri': externalUri
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = InsightCompanyData;

      return this.apiClient.callApi(
        '/Insight/getCompanyDataFromUri', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightLoadManyRootInsightsWithRepliesPut operation.
     * @callback module:api/InsightApi~insightLoadManyRootInsightsWithRepliesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadManyRootInsightsWithReplies
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/InsightApi~insightLoadManyRootInsightsWithRepliesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightLoadManyRootInsightsWithRepliesPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightLoadManyRootInsightsWithRepliesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightLoadManyRootInsightsWithRepliesPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/loadManyRootInsightsWithReplies', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightLoadRootInsightWithRepliesByInsightIDGet operation.
     * @callback module:api/InsightApi~insightLoadRootInsightWithRepliesByInsightIDGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadRootInsightWithRepliesByInsightID
     * @param {String} _4SAPIAppID 
     * @param {Integer} insightID 
     * @param {module:api/InsightApi~insightLoadRootInsightWithRepliesByInsightIDGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightLoadRootInsightWithRepliesByInsightIDGet = function(_4SAPIAppID, insightID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightLoadRootInsightWithRepliesByInsightIDGet";
      }

      // verify the required parameter 'insightID' is set
      if (insightID == undefined || insightID == null) {
        throw "Missing the required parameter 'insightID' when calling insightLoadRootInsightWithRepliesByInsightIDGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'insightID': insightID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/loadRootInsightWithRepliesByInsightID', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightLoadRootInsightWithRepliesGet operation.
     * @callback module:api/InsightApi~insightLoadRootInsightWithRepliesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadRootInsightWithReplies
     * @param {String} _4SAPIAppID 
     * @param {Integer} rootInsightID 
     * @param {module:api/InsightApi~insightLoadRootInsightWithRepliesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightLoadRootInsightWithRepliesGet = function(_4SAPIAppID, rootInsightID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightLoadRootInsightWithRepliesGet";
      }

      // verify the required parameter 'rootInsightID' is set
      if (rootInsightID == undefined || rootInsightID == null) {
        throw "Missing the required parameter 'rootInsightID' when calling insightLoadRootInsightWithRepliesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'rootInsightID': rootInsightID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/loadRootInsightWithReplies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightSearchAgendaFeedRootInsightsWithRepliesPut operation.
     * @callback module:api/InsightApi~insightSearchAgendaFeedRootInsightsWithRepliesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchAgendaFeedRootInsightsWithReplies
     * @param {String} _4SAPIAppID 
     * @param {module:model/InsightFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.rootItemsOffset  (default to 0)
     * @param {Integer} opts.rootItemsMaxCount  (default to 0)
     * @param {module:api/InsightApi~insightSearchAgendaFeedRootInsightsWithRepliesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightSearchAgendaFeedRootInsightsWithRepliesPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightSearchAgendaFeedRootInsightsWithRepliesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightSearchAgendaFeedRootInsightsWithRepliesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rootItemsOffset': opts['rootItemsOffset'],
        'rootItemsMaxCount': opts['rootItemsMaxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/searchAgendaFeedRootInsightsWithReplies', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightSearchRootInsightsWithRepliesByFilterPut operation.
     * @callback module:api/InsightApi~insightSearchRootInsightsWithRepliesByFilterPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchRootInsightsWithRepliesByFilter
     * @param {String} _4SAPIAppID 
     * @param {module:model/InsightFilter} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.rootItemsOffset  (default to 0)
     * @param {Integer} opts.rootItemsMaxCount  (default to 0)
     * @param {module:api/InsightApi~insightSearchRootInsightsWithRepliesByFilterPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightSearchRootInsightsWithRepliesByFilterPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightSearchRootInsightsWithRepliesByFilterPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling insightSearchRootInsightsWithRepliesByFilterPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rootItemsOffset': opts['rootItemsOffset'],
        'rootItemsMaxCount': opts['rootItemsMaxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/searchRootInsightsWithRepliesByFilter', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightSearchRootInsightsWithRepliesGet operation.
     * @callback module:api/InsightApi~insightSearchRootInsightsWithRepliesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InsightReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchRootInsightsWithReplies
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.rootItemsOffset  (default to 0)
     * @param {Integer} opts.rootItemsMaxCount  (default to 0)
     * @param {module:api/InsightApi~insightSearchRootInsightsWithRepliesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InsightReport>}
     */
    this.insightSearchRootInsightsWithRepliesGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightSearchRootInsightsWithRepliesGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'rootItemsOffset': opts['rootItemsOffset'],
        'rootItemsMaxCount': opts['rootItemsMaxCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [InsightReport];

      return this.apiClient.callApi(
        '/Insight/searchRootInsightsWithReplies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the insightTranslateInsightGet operation.
     * @callback module:api/InsightApi~insightTranslateInsightGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * translateInsight
     * @param {String} _4SAPIAppID 
     * @param {Integer} insightID 
     * @param {module:api/InsightApi~insightTranslateInsightGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.insightTranslateInsightGet = function(_4SAPIAppID, insightID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling insightTranslateInsightGet";
      }

      // verify the required parameter 'insightID' is set
      if (insightID == undefined || insightID == null) {
        throw "Missing the required parameter 'insightID' when calling insightTranslateInsightGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'insightID': insightID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Insight/translateInsight', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
